import { createSlice } from "@reduxjs/toolkit";
import CommonBase from "../../../../share/base/network/axiosNetwork";
import Immutable from "immutable";

const initialState = Immutable.fromJS({
  menus: [],
  loading: false,
  error: null,
});

export const menuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    // Lưu danh sách menu vào state
    SET_MENUS: function (state, action) {
      return state
        .set("menus", Immutable.fromJS(action.payload))
        .set("loading", false)
        .set("error", null);
    },
    // Set loading state
    SET_LOADING: function (state, action) {
      return state.set("loading", action.payload);
    },
    // Set error
    SET_ERROR: function (state, action) {
      return state.set("error", action.payload).set("loading", false);
    },
    // Clear menu
    CLEAR_MENUS: function (state, action) {
      return state.set("menus", Immutable.fromJS([])).set("error", null);
    },
  },
});

// create action sau nay se dung dispatch de tro vao
export const { SET_MENUS, SET_LOADING, SET_ERROR, CLEAR_MENUS } =
  menuSlice.actions;

export default menuSlice.reducer;
